import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderFileInfoModal = (id: string) => openPopupHelper({ popupName: popupNames.MOBILE_FILE_INFO_MODAL, data: { id } });
